<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 list-content nopads">
    <Transition name="fade">
      <div
        v-if="bridgeList.length > 0"
        class="list-content result-table pointer"
      >
        <vue3-datatable
          ref="resultTable"
          :rows="bridgeList"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="rowClicked"
        />
      </div>
    </Transition>
  </div>
</template>

<script>


import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'BridgeList',
    components: {Vue3Datatable},
    props: {
        bridges: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            bridgeList: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('bridge.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'code', title: this.$t('bridge.code'), sort: true, headerClass: 'routa-table-header'},
                {field: 'owner', title: this.$t('bridge.owner'), sort: true, headerClass: 'routa-table-header'},
                {field: 'maintainer', title: this.$t('bridge.maintainer'), sort: true, headerClass: 'routa-table-header'}]
        }
    },
    watch: {
        bridges() {
            this.bridgeList = []
            this.$nextTick(() => {
                this.bridgeList = this.bridges
            })
        }
    },
    mounted() {
        this.bridgeList = this.bridges
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        }
    }
}
</script>
